import { Button } from '@/components/ui/button';
import { KeyRound } from 'lucide-react';

export const AccessShortcutButton = ({ navigate, testId = 'access-shortcut-button' }) => (
  <Button
    type="button"
    variant="outline"
    size="icon"
    onClick={() => navigate('/acessos?trocar=1')}
    title="Acessos"
    aria-label="Acessos"
    className="border-slate-200 bg-white text-slate-500 transition-[background-color,color,border-color] duration-200 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900"
    data-testid={testId}
  >
    <KeyRound className="h-4 w-4" />
  </Button>
);
